module.exports = __webpack_public_path__ + "static/media/transportB.078348ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/transportB.svg
// module id = 549
// module chunks = 0